import React from "react";
import { useContext } from "react";
import { RouteProps, Route, Redirect } from "react-router";
import { Center, Spinner } from "@reverb-ui/react";
import {AuthContext} from "../contexts/auth";

type TPrivateRouteProps = RouteProps & {};

const LoadingState = () => (
  <Center w="full" h="full">
    <Spinner color="blue.500" />
  </Center>
);

export const PrivateRoute = (props: TPrivateRouteProps) => {
  const { token, loadingSSOToken } = useContext(AuthContext);

  if (loadingSSOToken) return <LoadingState />
  if (!token && !loadingSSOToken) return <Redirect to="/login" />

  return <Route {...props} />;
};
